export const getDegToClock = (degrees: number | undefined) => {
    if (degrees == undefined) {
        return ('00:00')
    }
    const tiltAngleDeg = (degrees + 360) % 360
      const angleInHours = tiltAngleDeg / 30
      let hour = Math.floor(angleInHours)
      let minutes = angleInHours - hour
      minutes = Math.round(minutes * 60)
      if (minutes === 60) {
        hour += 1
        minutes = 0
      }
      if (hour == 0) {
          hour = 12
      }
      if (hour == 13) {
        hour = 1
      }
      return hour + ':' + minutes.toFixed(0).padStart(2, '0')

}